import { render, staticRenderFns } from "./PageName.vue?vue&type=template&id=36e69b50&scoped=true"
import script from "./PageName.vue?vue&type=script&lang=ts"
export * from "./PageName.vue?vue&type=script&lang=ts"
import style0 from "./PageName.vue?vue&type=style&index=0&id=36e69b50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e69b50",
  null
  
)

export default component.exports